<!-- 套包组装单列表 -->
<template>
    <div id="setOrders" class="business-content-main set-order">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" v-if="permission.addSetOrder" @click="gotoSetOrderEdit(0, '')">{{
                    permission.addSetOrder
                }}</el-button>
                <el-button v-if="permission.printSetOrder" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()">{{
                    permission.printSetOrder
                }}</el-button>
                <el-button v-if="permission.scanStock" title="扫码备货" size="small" class="search-btn" type="warning" @click="scanPackOut()">{{ permission.scanStock }}</el-button>
                <el-button v-if="permission.scanPack" title="扫码组包" size="small" class="search-btn" type="warning" @click="scanPackage()">{{ permission.scanPack }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">组装单号</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.OrderCode" placeholder="组装单号"></el-input>
                <div class="search-name">仓库</div>
                <el-select v-model="searchData.WarehouseId" class="search-item" size="small" filterable clearable remote>
                    <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId" v-bind:key="optionItem.index">
                        <span style="float: left">{{ optionItem.WarehouseName }}</span>
                        <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                    </el-option>
                </el-select>
                <div class="search-name">组装状态</div>
                <el-select class="search-item" size="small" v-model="searchData.State">
                    <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                </el-select>
                <div class="search-name">创建人</div>
                <el-select v-model="searchData.SId" size="small" class="search-item" filterable placeholder="请选择" clearable>
                    <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                </el-select>
                <div class="search-name">更新日期</div>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <template v-if="noData">
            <div class="no-data">暂无数据</div>
        </template>
        <template v-else>
            <div class="table-ctn">
                <el-table
                    ref="refTable"
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    border
                    style="width: 100%"
                    @cell-dblclick="handleDBClick"
                    @selection-change="handleSelectionChange"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column width="190px" label="组装单号">
                        <template slot-scope="scope">
                            <el-badge :value="'打印' + scope.row.PrintedCount + '次'" class="mark" type="danger" v-if="scope.row.PrintedCount > 0">
                                {{ scope.row.SetOrderCode }}
                            </el-badge>
                            {{ scope.row.PrintedCount > 0 ? '' : scope.row.SetOrderCode }}
                        </template>
                    </el-table-column>
                    <el-table-column min-width="160px" prop="Name" label="仓库" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.Name }}
                             <span style="color: #8492a6" v-if="scope.row.Type == 1"> (前置仓)</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="120px" prop="NeedTime" label="期限时间" show-overflow-tooltip
                        ><template slot-scope="scope"> {{ (scope.row.NeedTime || '').split(' ')[0] }}</template></el-table-column
                    >
                    <el-table-column min-width="180px" prop="Remark" label="备注" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120px" label="状态" show-overflow-tooltip
                        ><template slot-scope="scope"> {{ scope.row.State | stateHandle }}</template></el-table-column
                    >
                    <el-table-column width="180px" prop="UpdateTime" label="更新时间" show-overflow-tooltip></el-table-column>
                    <el-table-column width="120px" prop="Updator" label="最后更新人" show-overflow-tooltip></el-table-column>
                    <el-table-column fixed="right" label="操作" :autoWidth="true">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button type="text" size="mini" @click="gotoSetOrderEdit(2, scope.row.SetOrderId)" v-if="permission.editSetOrder && scope.row.State == 0">{{
                                    permission.editSetOrder
                                }}</el-button>
                                <el-button
                                    type="text"
                                    size="mini"
                                    @click="gotoSetOrderEdit(4, scope.row.SetOrderId)"
                                    v-if="permission.modifyOrder && (scope.row.State == 1 || scope.row.State == 3)"
                                    >{{ permission.modifyOrder }}</el-button
                                >
                                <el-button type="text" size="mini" @click="submit(scope.row)" v-if="permission.submitSetOrder && scope.row.State == 0">{{
                                    permission.submitSetOrder
                                }}</el-button>
                                <el-button v-if="permission.pack && scope.row.State == 1 && scope.row.Type == 0" type="text" size="mini" @click="gotoPack(scope.row.SetOrderId)">{{
                                    permission.pack
                                }}</el-button>
                                <el-button type="text" size="mini" @click="showPrintLabelsDialog(scope.row)" v-if="permission.printLabel && scope.row.State == 3">{{
                                    scope.row.IsAllPrintedLabel ? '查看标签' : permission.printLabel
                                }}</el-button>
                                <el-button v-if="permission.scanStock && scope.row.State == 1 && scope.row.Type == 0" type="text" size="mini" @click="scanPackOut(scope.row.SetOrderId)">{{
                                    permission.scanStock
                                }}</el-button>
                                <el-button
                                    type="text"
                                    size="mini"
                                    style="color: orange"
                                    @click="cancelSetOrder(scope.row)"
                                    v-if="permission.cancelSetOrder && scope.row.State == 1 && scope.row.IsCanCancel"
                                    >{{ permission.cancelSetOrder }}</el-button
                                >
                                <el-button type="text" size="mini" style="color: red" @click="delSetOrder(scope.row)" v-if="permission.delSetOrder && scope.row.State == 0">{{
                                    permission.delSetOrder
                                }}</el-button>
                                <el-button type="text" size="mini" @click="opRecords(scope.row)" v-if="permission.opRecords">{{
                                    permission.opRecords
                                }}</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                ></el-pagination>
            </div>
        </template>
        <!--  打印  -->
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="dialogVisible" width="870px">
            <div class="dialog-content" v-if="dialogVisible">
                <printSetOrder @closeDialog="closeDialog" :printIds="idList"></printSetOrder>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="setVisible" width="1200px">
            <div v-if="setVisible">
                <setDetails :SetId="setId" :Type="type" @closeDialog="closeSetDialog"></setDetails>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="更新日期" :visible.sync="timeVisible" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="打印组装单套包商品标签" :visible.sync="showPrintOrderDialog" width="1200px">
            <div class="dialog-content" v-if="showPrintOrderDialog">
                <printSetOrderLabels @closeDialog="closePrintLabelsDialog" :SetOrderId="setOrderId"></printSetOrderLabels>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="组包单的操作记录" :visible.sync="OrderLifesVisible" width="1000px">
            <div class="dialog-content" v-if="OrderLifesVisible">
                <ordersLifes :OrderId="setOrderId" :OrderType="12" @closeDialog="closeOrderLifesDialog"></ordersLifes>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import setDetails from '@/components/business/goods/setDetails';
import printSetOrder from '@/components/business/goods/printSetOrder';
import timePicker from '@/components/common/timePicker';
import printSetOrderLabels from '@/components/business/goods/printSetOrderLabels.vue';
import ordersLifes from "@/components/common/ordersLifes";
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: 'setOrders',
    components: {
        breadcrumb,
        elTableColumn,
        setDetails,
        timePicker,
        ordersLifes,
        printSetOrder,
        printSetOrderLabels
    },
    data() {
        return {
            title: '新增套包',
            multipleSelection: null,
            idList: [],
            setOrderId: '',
            OrderLifesVisible : false,
            showPrintOrderDialog: false,
            type: 0,
            noData: false,
            setVisible: false, //编辑
            timeVisible: false,
            dialogVisible: false,
            searchData: {
                WarehouseId: '',
                SId: '',
                State: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            goodsCategories: [],
            WarehouseList: [],
            tableData: [],
            tableDataLength: 0,
            permission: {},
            SIdList: [],
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未提交', Value: '0' },
                { Text: '已提交', Value: '1' },
                { Text: '已备货', Value: '3' },
                { Text: '已组包', Value: '5' },
                { Text: '已取消', Value: '4' }
            ]
        };
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            this.getTableData();
        } else {
            this.doLayout('refTable');
        }
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.initSearchSelectData();
        this.getTableData();
        this.permission = this.$util.getPermission('SetOrderManage');
    },
    filters: {
        stateHandle(value) {
            if (value == 0) {
                return '未提交';
            } else if (value == 1) {
                return '已提交';
            } else if (value == 3) {
                return '已备货';
            } else if (value == 4) {
                return '已取消';
            } else if (value == 5) {
                return '已组包';
            }
        }
    },
    methods: {
        initSearchSelectData() {
            this.getWarehouse();
            this.getSIdList();
        },
        gotoSetOrderEdit(type, setOrderId) {
            this.$router.push(`/inventoryManage/goods/sets/setOrderEdit?type=${type}&SetOrderId=${setOrderId}`);
        },
        gotoPack(setOrderId) {
            this.$router.push(`/inventoryManage/goods/sets/setOrderEdit?type=3&SetOrderId=${setOrderId}`);
        },
        scanPackOut(setOrderId) {
            if (setOrderId) this.$router.push(`/inventoryManage/goods/sets/setOrderScanOut?stype=1&SetOrderId=${setOrderId}`);
            else this.$router.push(`/inventoryManage/goods/sets/setOrderScanOut?stype=0`);
        },
        scanPackage() {
            this.$router.push(`/inventoryManage/goods/sets/setOrderScanPack`);
        },

        closeSetDialog() {
            this.setVisible = false;
        },
        // 重置表单
        resetSearch() {
            this.goodsType = '';
            this.searchData = {
                WarehouseId: '',
                SId: '',
                State: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetEnterpriseSetOrders',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        return;
                    }
                    this.noData = false;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        delSetOrder(row) {
            let that = this;
            that.$util.elConfirm({
                content: '确定删除该组装单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpGoods/DelEnterpriseSetOrder?SetOrderId=${row.SetOrderId}`
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('成功删除组装单数据');
                                that.getTableData();
                            } else that.$util.successMsg(res.errmsg);
                        });
                }
            });
        },
        cancelSetOrder(row) {
            let that = this;
            that.$util.elConfirm({
                content: '确定取消该组装单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpGoods/CancelEnterpriseSetOrder?SetOrderId=${row.SetOrderId}`
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('成功取消改组装单');
                                that.getTableData();
                            } else that.$util.successMsg(res.errmsg);
                        });
                }
            });
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.WarehouseList = data;
            });
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        submit(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要提交该组装单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpGoods/SubmitEnterpriseSetOrder?SetOrderId=${row.SetOrderId}`
                        })
                        .then(() => {
                            that.$util.successMsg('提交成功');
                            that.getTableData();
                        });
                }
            });
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event.SetOrderId) {
                this.gotoSetOrderEdit(1, event.SetOrderId);
            }
        },
        closeDialog() {
            this.dialogVisible = false;
            this.getTableData();
        },
        // 打印
        print() {
            if (this.idList.length == 0) {
                this.$util.warningMsg('请选择一张组装单打印');
                return;
            } else if (this.idList.length > 1) {
                this.$util.warningMsg('只能选择一张组装单打印');
                return;
            }
            if (this.multipleSelection[0].State == 2) {
                this.$util.warningMsg('不能打印已删除的组装单');
                return;
            }
            if (this.multipleSelection[0].State == 4) {
                this.$util.warningMsg('不能打印已取消的组装单');
                return;
            }
            if (this.multipleSelection[0].State == 0) {
                this.$util.warningMsg('不能打印未提交的组装单');
                return;
            }
            if (this.multipleSelection[0].State == 5) {
                this.$util.warningMsg('不能打印已组包的组装单');
                return;
            }
            this.dialogVisible = true;
        },
        opRecords(item) {
            if (item) {
                this.setOrderId = item.SetOrderId;
                this.OrderLifesVisible = true;
            } else {
                this.$util.warningMsg("订单数据异常，请刷新后重新操作");
            }
        },
        closeOrderLifesDialog() {
            this.OrderLifesVisible = false;
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].SetOrderId);
            }
            this.idList = idList;
        },
        closePrintLabelsDialog() {
            this.setOrderId = '';
            this.showPrintOrderDialog = false;
        },
        showPrintLabelsDialog(row) {
            if (row) {
                this.setOrderId = row.SetOrderId;
                this.showPrintOrderDialog = true;
            } else {
                this.$util.warningMsg('请选择组装单进行打印标签');
                return;
            }
        }
    }
};
</script>
<style lang="less">
.set-order {
    .el-table__row {
        td:nth-child(2) {
            .cell {
                overflow: visible;
            }
        }
    }
}
</style>
